module.exports = __webpack_public_path__ + "img/thumb_12.4bd66182.jpg";